import React from "react";
import styles from "./PhoneInput.module.scss";
// import PhoneInput from "react-phone-number-input";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

const PhoneInputComp = ({
  label,
  placeholder,
  value,
  onChange,
  required,
  error,
  disabled,
}) => {
  return (
    <div className={styles.phone_input_label_container}>
      <label className={styles.label}>
        {label} {required && <span style={{ color: "red" }}>*</span>}
      </label>
      <PhoneInput
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        enableSearch={true}
        disableSearchIcon={true}
        country="in"
        disabled={disabled}
        className={error ? styles.error_input : ""}
      />
      {error && <div className={styles.error_text}>{error}</div>}
    </div>
  );
};

export default PhoneInputComp;
